(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.fdlpTable = {
    attach: function (context) {
      new DataTable('table.display', {
          layout: {
              top2Start: 'search',
              top2End: {
                  buttons: [
                      {
                          extend: 'print',
                          init: function(api, node, config) {
                              $(node).removeClass('dt-button');
                              $(node).addClass('button button--action button--small');
                          },
                          exportOptions: {
                              stripHtml: false,
                              format: {
                                  body: function (data, row, column, node) {
                                      // Process Data before exporting.
                                      return processString(data);
                                  }
                              }
                          }
                      },
                      {
                          extend: 'copyHtml5',
                          init: function(api, node, config) {
                              $(node).removeClass('dt-button');
                              $(node).addClass('button button--action button--small');
                          },
                          exportOptions: {
                              stripHtml: false,
                              format: {
                                  body: function (data, row, column, node) {
                                      // Process Data before exporting.
                                      return processString(data);
                                  }
                              }
                          }
                      },
                      {
                          extend: 'csv',
                          init: function(api, node, config) {
                              $(node).removeClass('dt-button');
                              $(node).addClass('button button--action button--small');
                          },
                          exportOptions: {
                              stripHtml: false,
                          },
                          title: null,
                          customize: function(csv) {
                              var headerDisabled = $(".dataTable thead").hasClass('disabled');
                              if (headerDisabled) {
                                // Remove the first empty row.
                                var lines = csv.split('\n');
                                lines.shift();
                                return lines.join('\n');
                              }
                              return csv;
                          }
                      },
                      {
                          extend: 'excel',
                          init: function(api, node, config) {
                              $(node).removeClass('dt-button');
                              $(node).addClass('button button--action button--small');
                          },
                          exportOptions: {
                              stripHtml: false,
                              format: {
                                  body: function (data, row, column, node) {
                                      // Process Data before exporting.
                                      return processString(data);
                                  }
                              }
                          },
                      },
                      {
                          extend: 'pdf',
                          init: function(api, node, config) {
                              $(node).removeClass('dt-button');
                              $(node).addClass('button button--action button--small');
                          },
                          exportOptions: {
                              stripHtml: false,
                              format: {
                                  body: function (data, row, column, node) {
                                      // Process Data before exporting.
                                      return processString(data);
                                  }
                              }
                          },
                      },
                  ],
              },
              topStart: null,
              topEnd: 'pageLength',
          },
          headerCallback: function(thead, data, start, end, display) {
              var headerDisabled = $(".dataTable thead").hasClass('disabled');
              if (headerDisabled) {
                $(thead).empty();
              }
          },
          pagingType: 'simple_numbers',
          order: [],
          initComplete: function() {
              // Add Search placeholder text.
              // Clear the initial search
              this.api().search('').draw();
              var table = this;
              $('.dt-container input.dt-input').attr('placeholder', 'Filter Table...');
          }
      });

      // Helper Function to process string for each cell.
      function processString(text) {
        // Helper Function to extract the URL from an <a> tag
        function extractUrl(match) {
          let urlMatch = match.match(/href="([^"]*)"/i);
          return urlMatch ? urlMatch[1] : match;
        }
        let processedString = text.replace(/<a[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/gi, function(match) {
          return extractUrl(match);
        });

        // Remove/Sanitize non-links HTML.
        let sanitized = DataTable.util.stripHtml(processedString);
        return sanitized;
      }

    },
  };
})(jQuery, Drupal);
